'use client'

import React from 'react'

import ContactsHero from '@/components/sections/ContactsHero'
import ContactsInfo from '@/components/sections/ContactsInfo'
import ContactsLocation from '@/components/sections/ContactsLocation'
import FinalCTA from '@/components/sections/FinalCTA'
import HomeAmbientBackground from '@/components/sections/HomeAmbientBackground'

export default function ContactsClient() {
  return (
    <main className="min-h-screen text-white">
      <HomeAmbientBackground />

      <ContactsHero />

      <ContactsInfo />

      <ContactsLocation />

      <FinalCTA />
    </main>
  )
}
